import { render, staticRenderFns } from "./SettingsTestWebhooks.vue?vue&type=template&id=44fb6eb5&scoped=true"
import script from "./SettingsTestWebhooks.vue?vue&type=script&lang=js"
export * from "./SettingsTestWebhooks.vue?vue&type=script&lang=js"
import style0 from "./SettingsTestWebhooks.vue?vue&type=style&index=0&id=44fb6eb5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb6eb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fb6eb5')) {
      api.createRecord('44fb6eb5', component.options)
    } else {
      api.reload('44fb6eb5', component.options)
    }
    module.hot.accept("./SettingsTestWebhooks.vue?vue&type=template&id=44fb6eb5&scoped=true", function () {
      api.rerender('44fb6eb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsTestWebhooks.vue"
export default component.exports